import Axios from 'axios';
import Cookies from 'js-cookie';
import {baseURL} from './url';

export const instance = () => {
    return Axios.create({
        baseURL,
         headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer  ${Cookies.get('token')}`,
        },
    });
};